import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment';

export const SHOW_TOAST = new HttpContextToken<boolean>(() => true);

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private apiLoginUrl = `${environment.apiBaseUrl}/auth/login`
  private apiValidateOTPUrl = `${environment.apiBaseUrl}/auth/validate-otp`
  // endpoint to ask the backend to send a support email
  private apiSupportEmailUrl = `${environment.apiBaseUrl}/support-email`

  constructor(private http: HttpClient) {
  }

  sendOtp(email: string): Observable<any> {
    return this.http.post<any>(`${this.apiLoginUrl}`, { email })
  }

  validateOTP(email: string, otp: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${this.apiValidateOTPUrl}`, { email, otp }, { context: new HttpContext().set(SHOW_TOAST, false) });
  }

  sendSupportEmail(orderId: string, userName: string, customerName: string, userEmail: string, userPhone: string, message: string): Observable<any> {
    const payload = {
      orderId,
      userName,
      customerName,
      userEmail,
      userPhone,
      message,
      supportemail: environment.soporteEmail
    };
    return this.http.post<any>(`${this.apiSupportEmailUrl}`, payload);
  }
}
